import { compose } from 'recompose';

import DirectsItem from './directsItem';

const enhance = compose();

export default enhance(DirectsItem);
